import type { PrivacySectionConfig } from "../../../types/legal";

export const privacySections: PrivacySectionConfig[] = [
    { titleKey: "privacy_s1_title", textKey: "privacy_s1_text" },
    { titleKey: "privacy_s2_title", textKey: "privacy_s2_text" },
    { titleKey: "privacy_s3_title", textKey: "privacy_s3_text" },
    { titleKey: "privacy_s4_title", textKey: "privacy_s4_text" },
    { titleKey: "privacy_s5_title", textKey: "privacy_s5_text" },
    { titleKey: "privacy_s6_title", textKey: "privacy_s6_text" },
    { titleKey: "privacy_s7_title", textKey: "privacy_s7_text" },
    { titleKey: "privacy_s8_title", textKey: "privacy_s8_text" },
];
